import { getSiteCurrencyISO, SiteCurrency } from '../../data/models/locale'
import { store } from '../../store/store'
import { getMetrics } from '../metrics'
import { EventTypes } from '../middleware/ActionTypes'
import { ISignUpTrackingData } from './models/ISignUpTrackingData'

export function newsletterSignUp() {
  try {
    const metrics = getMetrics()
    metrics.api.track(EventTypes.NEWSLETTER_SIGNUP, getSignUpData())
  } catch (e) {
    console.error(`Metrics failed because: ${e}`)
  }
}

function getSignUpData(): ISignUpTrackingData {
  const state = Object.assign({}, store.getState())
  return {
    value: 1,
    currency: getSiteCurrencyISO(state.locale.currency || SiteCurrency.euro),
    trip_id: 50,
    name: 'signup',
    category: 'newsletter',
    country: state.locale.country,
  }
}

export function FacebookSignup(data: ISignUpTrackingData): any {
  return {
    value: data.value,
    currency: data.currency,
    content_id: data.trip_id,
    content_name: data.name,
    content_category: data.category,
  }
}

export function AdWordsSignup(data: ISignUpTrackingData): any {
  return {
    sendTo: '6kY3CI-snYMBEPn5ucwD',
    value: 1,
    currency: data.currency,
  }
}

export function GoogleSignup(data: ISignUpTrackingData): any {
  return {
    event_category: data.category,
  }
}

export function SnapchatSignup(data: ISignUpTrackingData): any {
  return {}
}
